var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#7048E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 9.66699V11.0003H17.9997V9.66699H19.333V11.0003H21.9997C22.3679 11.0003 22.6663 11.2988 22.6663 11.667V22.3337C22.6663 22.7019 22.3679 23.0003 21.9997 23.0003H9.99967C9.63149 23.0003 9.33301 22.7019 9.33301 22.3337V11.667C9.33301 11.2988 9.63149 11.0003 9.99967 11.0003H12.6663V9.66699H13.9997ZM21.333 16.3337H10.6663V21.667H21.333V16.3337ZM15.333 17.667V20.3337H11.9997V17.667H15.333ZM12.6663 12.3337H10.6663V15.0003H21.333V12.3337H19.333V13.667H17.9997V12.3337H13.9997V13.667H12.6663V12.3337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingsIcon);
export default __webpack_public_path__ + "static/media/MeetingsIcon.d3e2c8a1c3ac4dcd75fa88c28811d9a5.svg";
export { ForwardRef as ReactComponent };